// extracted by mini-css-extract-plugin
export default {"content":"LegalPageContent_content__9SPmW"};